import { getSpecLink } from "../helpers/api.js";
import { fileToBlob } from "../helpers/fileToBlob.js";
import { closeModal, openModal } from "./modals.js";

const managerMail = "info@mebelesd.ru";

// Глобальная переменная для ожидания ответа от iframe
let pdfResponsePromise = null;
let pdfResolve = null;
let pdfReject = null;

// Listener на ответ от iframe с готовым Blob
window.addEventListener("message", async (event) => {
    if (event.data.type === "pdf-ready") {
        if (pdfResolve) {
            pdfResolve(event.data);
        }
    } else if (event.data.type === "pdf-error") {
        if (pdfReject) {
            pdfReject(new Error(event.data.error));
        }
    }
});

// Обработчик кнопки checkout-submit
document.getElementById("checkout-submit").addEventListener("pointerdown", async () => {
    if (!validateForm()) {
        console.warn("Форма не валидна!");
        return;
    }

    let modalTitle = "Письмо отправлено!";
    let modalBody = "Файл со спецификациями на товары приложен к письму.";

    const input = document.getElementById("checkout_file_upload_input");
    const file = input.files[0];

    const blobFileDetails = file ? fileToBlob(file) : null;
    const fileExtension = file?.name.split(".").at(-1);
    const blobFileDetailsObj = file
        ? {
              blob: blobFileDetails,
              fileName: `Реквизиты.${fileExtension}`,
              mimeType: { type: blobFileDetails.type },
          }
        : null;

    const specDataManager = await createSpecData(true);
    const specDataClient = await createSpecData(false);

    // Promise для ожидания Blob от iframe
    pdfResponsePromise = new Promise((resolve, reject) => {
        pdfResolve = resolve;
        pdfReject = reject;
    });

    const iframe = document.getElementById("iframe");
    iframe.contentWindow.postMessage({ type: "send-pdf", specDataClient }, "*");

    let sendMailError = null;

    try {
        // Ждем ответ от iframe (timeout 30 сек)
        const response = await Promise.race([
            pdfResponsePromise,
            new Promise((_, reject) => setTimeout(() => reject(new Error("Timeout: PDF generation failed")), 30000)),
        ]);

        // === Если PDF сгенерировался ===
        const blobObj = {
            blob: response.blob,
            fileName: response.fileName,
            mimeType: { type: response.mimeType },
        };

        // Отправляем письма
        try {
            await sendMail(specDataManager, null, blobFileDetailsObj); // менеджеру
            await sendMail(specDataClient, blobObj, null); // клиенту
        } catch (error) {
            sendMailError = error;
        }
    } catch (pdfError) {
        // === Если проект пустой ===
        if (pdfError.message.includes("Пока нечего сохранять в PDF")) {
            console.warn(pdfError.message);
            modalTitle = "Письмо не отправлено!";
            modalBody = "Проект пустой. Пожалуйста, добавьте товары в проект и повторите отправку.";

            // ⚠️ Просто выходим, ничего не отправляем
            closeModal("checkout-modal");
            setTimeout(() => openModal("send_mail_modal", null, null, modalTitle, modalBody), 1000);
            setTimeout(() => closeModal("send_mail_modal"), 3000);
            return;
        }

        // === Если другая ошибка PDF ===
        console.error("Failed to generate PDF:", pdfError);
        try {
            await sendMail(specDataManager, null, blobFileDetailsObj); // менеджеру
            await sendMail(specDataClient, null, null); // клиенту
        } catch (error) {
            sendMailError = error;
        }
        modalBody = "Файл со спецификациями не удалось прикрепить, но письмо отправлено.";
    }

    // Обработка ошибок sendMail
    if (sendMailError) {
        if (sendMailError.statusCode === 413) {
            console.warn("Слишком большой вложенный файл. Повторная попытка без вложения.", sendMailError);
            try {
                await sendMail(specDataClient, null, null);
                modalBody = "Спецификацию на товары можно скачать по ссылке на проект, приложенной к письму.";
            } catch (finalError) {
                modalTitle = "Письмо не отправлено!";
                modalBody = "В процессе повторной отправки возникла ошибка. Попробуйте повторить позже.";
                console.error(finalError);
            }
        } else {
            modalTitle = "Письмо не отправлено!";
            modalBody = "В процессе отправки возникла непредвиденная ошибка. Попробуйте повторить позже.";
            console.error(sendMailError);
        }
    }

    closeModal("checkout-modal");
    setTimeout(() => openModal("send_mail_modal", null, null, modalTitle, modalBody), 300);
    setTimeout(() => closeModal("send_mail_modal"), 3000);
});

// Обновленный sendMail с возвратом Promise и гарантированным error.status
export async function sendMail(specData, blobObj = null, blobFileDetails = null) {
    const { to, subject, html } = specData;
    const formData = new FormData();
    formData.append("to", to);
    formData.append("subject", subject);
    formData.append("html", html);

    // массив для всех возможных вложений
    const attachments = [];

    if (blobObj) {
        const { blob, fileName, mimeType } = blobObj;
        const encodedName = encodeMimeHeader(fileName);
        attachments.push(new File([blob], encodedName, { type: mimeType.type }));
    }

    if (blobFileDetails) {
        const { blob, fileName, mimeType } = blobFileDetails;
        const encodedName = encodeMimeHeader(fileName);
        attachments.push(new File([blob], encodedName, { type: mimeType.type }));
    }

    // добавляем все вложения в formData
    attachments.forEach((file) => {
        formData.append("attachments", file);
    });

    const API_URL = "https://esd-mebel.ru/mail/send";

    let res;
    try {
        res = await fetch(API_URL, {
            method: "POST",
            body: formData,
        });
    } catch (networkError) {
        const err = new Error("Network error: " + networkError.message);
        err.status = null;
        throw err;
    }

    if (!res.ok) {
        const text = await res.text();
        const err = new Error(text || "Email send failed");
        err.status = res.status;
        throw err;
    }

    return res;
}

async function createSpecData(isManager = false) {
    const form = document.getElementById("checkout-form");
    const formData = new FormData(form);
    const name = formData.get("checkout__name");
    const phone = formData.get("checkout__phone");
    const email = formData.get("checkout__email");
    const payer = formData.get("payer_type");
    const request = formData.get("request_type");
    const info = formData.get("checkout__info");
    const adress = formData.get("checkout__adress");
    const link = await getSpecLink(false);
    const to = isManager ? managerMail : email;
    // const to = email;

    const valuesMapPayer = {
        individual: "Физ. лицо",
        company: "Юр. лицо",
    };

    const resPayer = valuesMapPayer[payer];

    const valuesMapRequest = {
        invoice: "Счёт",
        proposal: "Коммерческое предложение",
    };

    const resRequest = valuesMapRequest[request];

    const subject = "Заявка из конфигуратора Мебель Есд";
    const html = `
        <h1>${isManager ? "Заявка из конфигуратора Мебель Есд" : "Благодарим Вас за заказ!"}</h1>
        ${
            isManager
                ? `<p>Имя: ${name}</p>
                  <p>Телефон: ${phone}</p>
                  <p>Email: ${email}</p>
                  <p>Оплата: ${resPayer}</p>
                  <p>Запрос на: ${resRequest}</p>
                  <p>ИНН компании или комментарий: ${info}</p>
                  <p>Адрес доставки: ${adress}</p>`
                : ""
        }
        <p>Ссылка на проект: <a href="${link}">${link}</a></p>
    `;

    return { to, subject, html };
}

export function validateForm() {
    const nameInput = document.querySelector('input[name="checkout__name"]');
    const emailInput = document.querySelector('input[name="checkout__email"]');
    const phoneInput = document.querySelector('input[name="checkout__phone"]');
    const infoInput = document.querySelector('textarea[name="checkout__info"]');
    const fileUploadWrap = document.querySelector("#checkout-form .custom-file-upload");

    resetValidationStyles([nameInput, emailInput, phoneInput, infoInput]);

    let isValid = true;

    if (nameInput.value.trim() === "") {
        nameInput.classList.add("error");
        isValid = false;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(emailInput.value.trim())) {
        emailInput.classList.add("error");
        isValid = false;
    }

    const phoneDigits = phoneInput.dataset.raw || "";
    if (phoneDigits.trim() === "" || phoneDigits.replace(/\D/g, "").length !== 10) {
        phoneInput.classList.add("error");
        isValid = false;
    }

    if (fileUploadWrap.classList.contains("error")) {
        isValid = false;
    }

    return isValid;
}

function resetValidationStyles(inputs) {
    inputs.forEach((input) => {
        input.classList.remove("error"); // Сбрасываем стиль рамки
    });
}

function encodeMimeHeader(name) {
    const utf8 = new TextEncoder().encode(name);
    let binary = "";
    utf8.forEach((b) => (binary += String.fromCharCode(b)));
    return "=?UTF-8?B?" + btoa(binary) + "?=";
}
